import { PropsWithChildren } from "react";
import styled from "styled-components";

export function PageContainer({
  children,
  style,
}: PropsWithChildren<{ style?: object }>) {
  return <PContainer style={style}>{children}</PContainer>;
}

export const PContainer = styled.div`
  position: relative;
  // todo height should auth update
  // container height - header height - header margin
  min-height: calc(100% - 22px - 20px);
  overflow: scroll;
  background: #292b2f;
  overflow-x: hidden;
`;
